<template>
  <button
      :type="type"
      class="button loader-button"
      :class="[color, {loading: loading}, {block: block}]"
      :disabled="loading || disabled"
  >
    <div class="flex-inline flex-center">
      <svg-icon id="loading" class="spin"></svg-icon>
      {{ label }}
      <svg-icon :id="afterIcon" v-if="afterIcon"></svg-icon>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    afterIcon: {
      type: String,
    },

    color: {
      type: String,
      default: 'primary',
    },

    label: {
      type: String,
      required: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
      default: 'button',
    },

    block: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {}
  },
}
</script>
